<template>
  <div class="has-background-white is-border is-margin-bottom">
    <div class="columns is-gapless">
      <div class="column is-6 is-7-widescreen is-8-fullhd is-padding">
        <stats-chart
          v-if="chartData"
          :entities="chartData"
          :chart-line-configs="chartLineConfigs"
          :chart-config="chartConfig"></stats-chart>
      </div>
      <div class="column is-6 is-5-widescreen is-4-fullhd is-border-left">
        <div class="is-padding">
          <div class="title is-3">
            CA total immo
          </div>
          <div class="is-wMaxContent">
            <div class="columns is-gapless is-vcentered is-marginless">
              <div class="column is-narrow is-margin-right-small">
                <div class="title is-2">
                  € {{ totalSales.chart_valid_CA | round(0) | prettyPrice }}
                </div>
              </div>
              <div class="column is-narrow">
                <stat-value
                  v-if="reference"
                  :value="differences.chart_valid_CA"
                  :percentage="true"
                  :is-tag="true"
                  :difference="true"
                  classes="has-text-white"></stat-value>
              </div>
            </div>
            <div
              class="has-text-left is-size-6 is-margin-top-xxsmall"
              v-if="reference">
              <i>
                <span v-if="filters && filters.status.includes('pre_reserved')">Pré-Résa</span>
                <span v-if="filters && filters.status.includes('pre_reserved') && (filters.status.includes('reserved') || filters.status.includes('sold'))"> + </span>
                <span v-if="filters && filters.status.includes('reserved')">Résa</span>
                <span v-if="filters && filters.status.includes('reserved') && filters.status.includes('sold')"> + </span>
                <span v-if="filters && filters.status.includes('sold')">Acte</span>
                <span> - Par rapport à : {{ reference.label }}</span>
              </i>
            </div>
          </div>
          <!-- <div class="is-margin-top">
            <div class="title is-6 is-margin-bottom-xsmall">Objectif sur la période : 360 ventes</div>
            <div>
              <progress max="100" class="progress is-success is-radiusless" value="30">%</progress>
            </div>
          </div> -->
        </div>
        <div class="is-padding is-border-top has-background-white-bis">
          <div class="columns">
            <div class="column">
              <div class="title is-6 is-uppercase is-marginless">
                CA équipe interne
              </div>
              <div class="columns is-gapless is-vcentered is-marginless is-padding-top-xxsmall">
                <div class="column is-narrow is-margin-right-small">
                  <div class="title is-4">
                    {{ totalStatsIntern | round(0) | prettyPrice }} €
                  </div>
                </div>
                <div
                  class="column is-narrow"
                  v-if="reference">
                  <stat-value
                    :value="totalStatsReferenceIntern"
                    :percentage="true"
                    :difference="true"></stat-value>
                </div>
              </div>
              <div>
                <router-link
                  :to="{name: 'StatsSellers', query: {panel: 'SELLERS'}}"
                  class="is-size-6 is-italic is-underline">
                  Afficher le détail
                </router-link>
              </div>
            </div>
            <div class="column">
              <div class="title is-6 is-uppercase is-marginless">
                CA prescripteurs
              </div>
              <div class="columns is-gapless is-vcentered is-marginless is-padding-top-xxsmall">
                <div class="column is-narrow is-margin-right-small">
                  <div class="title is-4">
                    {{ totalStatsExtern | round(0) | prettyPrice }} €
                  </div>
                </div>
                <div
                  class="column is-narrow"
                  v-if="reference">
                  <stat-value
                    :value="totalStatsReferenceExtern"
                    :percentage="true"
                    :difference="true"></stat-value>
                </div>
              </div>
              <div>
                <router-link
                  :to="{name: 'StatsSellers', query: {panel: 'ACCOUNT'}}"
                  class="is-size-6 is-italic is-underline">
                  Afficher le détail
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="is-padding is-border-top">
          <div class="columns is-multiline">
            <div class="column is-6">
              <div
                v-if="from === 'Program'"
                class="columns is-vcentered is-gapless is-border-bottom is-marginless is-padding-top-xxsmall is-padding-bottom-xxsmall is-maxW220p">
                <div class="column">
                  Options en cours
                </div>
                <div class="column is-narrow is-w88p">
                  <span>{{ options_count }}</span>
                </div>
              </div>
              <div class="columns is-vcentered is-gapless is-border-bottom is-marginless is-padding-top-xxsmall is-padding-bottom-xxsmall is-maxW220p">
                <div class="column">
                  Pré-Réservation
                </div>
                <div class="column is-narrow is-w88p">
                  <span>{{ totalSales.prereservation_count }}</span>
                  <span
                    class="is-padding-left-xxsmall has-text-success is-size-7"
                    v-if="reference">
                    <stat-value
                      :value="differences.prereservation_count"
                      :percentage="true"
                      :difference="true"></stat-value>
                  </span>
                </div>
              </div>
              <div class="columns is-vcentered is-gapless is-border-bottom is-marginless is-padding-top-xxsmall is-padding-bottom-xxsmall is-maxW220p">
                <div class="column">
                  Réservations
                </div>
                <div class="column is-narrow is-w88p">
                  <span>{{ totalSales.reservation_count }}</span>
                  <span
                    class="is-padding-left-xxsmall has-text-success is-size-7"
                    v-if="reference">
                    <stat-value
                      :value="differences.reservation_count"
                      :percentage="true"
                      :difference="true"></stat-value>
                  </span>
                </div>
              </div>
              <div class="columns is-vcentered is-gapless is-border-bottom is-marginless is-padding-top-xxsmall is-padding-bottom-xxsmall is-maxW220p">
                <div class="column">
                  Actes
                </div>
                <div class="column is-narrow is-w88p">
                  <span>{{ totalSales.sold_count }}</span>
                  <span
                    class="is-padding-left-xxsmall has-text-success is-size-7"
                    v-if="reference">
                    <stat-value
                      :value="differences.sold_count"
                      :percentage="true"
                      :difference="true"></stat-value>
                  </span>
                </div>
              </div>
              <div class="columns is-vcentered is-gapless is-border-bottom is-marginless is-padding-top-xxsmall is-padding-bottom-xxsmall is-maxW220p">
                <div class="column">
                  Annulation
                </div>
                <div class="column is-narrow is-w88p">
                  <span>{{ totalSales.canceled_count }}</span>
                  <span
                    class="is-padding-left-xxsmall has-text-success is-size-7"
                    v-if="reference">
                    <stat-value
                      :value="differences.canceled_count"
                      :percentage="true"
                      :difference="true"></stat-value>
                  </span>
                </div>
              </div>
            </div>
            <div class="column is-6">
              <div class="columns is-vcentered is-gapless is-border-bottom is-marginless is-padding-top-xxsmall is-padding-bottom-xxsmall is-maxW220p">
                <div class="column">
                  Taux d'écoulement
                  <span
                    class="is-margin-left-xsmall icon is-medium"
                    v-helper.left.small="'4n26uiR296GE4HyEfCQrXJ'">
                    <i class="fal fa-question-circle has-text-grey"></i>
                  </span>
                </div>
                <div class="column is-narrow ">
                  <span>{{ flowRate || 0 | prettyPrice }} %</span>
                </div>
              </div>
              <div class="columns is-vcentered is-gapless is-border-bottom is-marginless is-padding-top-xxsmall is-padding-bottom-xxsmall is-maxW220p">
                <div class="column">
                  Taux d'annulation
                </div>
                <div class="column is-narrow">
                  <span>{{ cancelRate || 0 | prettyPrice }} %</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="is-padding-right is-padding-left is-border-top">
          <div class="is-flex">
            <div class="is-self-centered">
              <div class="title is-5">
                Référence
              </div>
            </div>
            <div class="select has-background-transparent">
              <select
                id="reference"
                @change="updateReference()"
                v-model="reference"
                class="is-borderless is-shadowless has-text-weight-medium">
                <option
                  v-for="period in referenceDatas"
                  :value="period"
                  :key="'reference' + period.value">
                  {{ period.label }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div
          v-if="from === 'Program'"
          class="is-padding-right is-padding-left is-padding-bottom">
          <router-link
            :to="{name: 'StatsSales'}"
            class="">
            <span class="is-size-6 is-padding-right-xxsmall is-underline is-italic">
              Accédez à toutes les données statistiques de vos programmes
            </span>
            <i class="far fa-arrow-right"></i>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'StatsSalesGraph',
  components: {
    StatValue: () => import('@/components/statistics/StatValue'),
    StatsChart: () => import('../StatsChart')
  },
  props: {
    programOptions: {
      type: Array,
      default: () => []
    },
    from: {
      type: String
    },
    statsSales: {
      type: Array,
      required: true
    },
    totalSales: {
      type: Object,
      required: true
    },
    totalReferenceSales: Object,
    filters: Object,
    referenceSelected: Object,
    referenceDatas: Array,
    statsReferenceSales: Array,
    flowRate: Number
  },
  data () {
    return {
      reference: null,
      chartConfig: {
        legendPosition: 'top',
        lowerCaseText: true,
        bulletSize: 6
      }
    }
  },
  computed: {
    ...mapGetters(['accountPk']),
    chartLineConfigs () {
      return [
        { name: 'Pré-Réservation', key: 'prereservation_count', color: '#5cb4eb' },
        { name: 'Réservation', key: 'reservation_count', color: '#2666b4' },
        { name: 'Acte', key: 'sold_count', color: '#060811' },
        { name: 'Annulations', key: 'canceled_count', color: '#db534d' }
      ]
    },
    options_count () {
      if (this.programOptions && this.from === 'Program') {
        const okStatus = ['waiting_list', 'approved']
        return this.programOptions.filter(x => okStatus.includes(x.status)).length
      } else {
        return 0
      }
    },
    differences () {
      if (!this.totalReferenceSales) return {}
      return {
        valid_CA: this.totalReferenceSales.valid_CA > 0 ? (this.totalSales.valid_CA - this.totalReferenceSales.valid_CA) / this.totalReferenceSales.valid_CA * 100 : 0,
        prereservation_count: this.totalReferenceSales.prereservation_count > 0 ? (this.totalSales.prereservation_count - this.totalReferenceSales.prereservation_count) / this.totalReferenceSales.prereservation_count * 100 : 0,
        reservation_count: this.totalReferenceSales.reservation_count > 0 ? (this.totalSales.reservation_count - this.totalReferenceSales.reservation_count) / this.totalReferenceSales.reservation_count * 100 : 0,
        sold_count: this.totalReferenceSales.sold_count > 0 ? (this.totalSales.sold_count - this.totalReferenceSales.sold_count) / this.totalReferenceSales.sold_count * 100 : 0,
        canceled_count: this.totalReferenceSales.canceled_count ? (this.totalSales.canceled_count - this.totalReferenceSales.canceled_count) / this.totalReferenceSales.canceled_count * 100 : 0,
        chart_valid_CA: this.totalReferenceSales.chart_valid_CA ? (this.totalSales.chart_valid_CA - this.totalReferenceSales.chart_valid_CA) / this.totalReferenceSales.chart_valid_CA * 100 : 0
      }
    },
    chartData () {
      let data = {}
      this.statsSales.forEach(x => {
        let date = moment(x.pre_reservation_date)
        if (x.sale_date && x.status !== 'canceled') date = moment(x.sale_date)
        else if (x.signature_date && x.status !== 'canceled') date = moment(x.signature_date)
        let formatedDate = date.format('YYYY-MM')
        if (!(formatedDate in data)) {
          data[formatedDate] = {
            date: date.toDate(),
            sales: [x]
          }
        } else {
          data[formatedDate].sales.push(x)
        }
      })
      return Object.values(data).map(x => {
        return {
          date: x.date,
          prereservation_count: x.sales.filter(y => y.status === 'pre_reserved').length,
          reservation_count: x.sales.filter(y => y.status === 'reserved').length,
          sold_count: x.sales.filter(y => y.status === 'sold').length,
          canceled_count: x.sales.filter(y => y.status === 'canceled').length
        }
      }).sort((a, b) => {
        return moment(a.date).format('x') - moment(b.date).format('x')
      })
    },
    totalStatsIntern () {
      return this.statsSales.filter(x => ['sold', 'reserved'].includes(x.status)).reduce((a, b) => {
        if (b.account.pk === this.accountPk) {
          return a + b.sale_price_ttc
        } else return a + 0
      }, 0)
    },
    totalStatsExtern () {
      return this.statsSales.filter(x => ['sold', 'reserved'].includes(x.status)).reduce((a, b) => {
        if (b.account.pk !== this.accountPk) {
          return a + b.sale_price_ttc
        } else return a + 0
      }, 0)
    },
    totalStatsReferenceIntern () {
      let referenceTotal = this.statsReferenceSales.filter(x => ['sold', 'reserved'].includes(x.status)).reduce((a, b) => {
        if (b.account.pk === this.accountPk) {
          return a + b.sale_price_ttc
        } else return a + 0
      }, 0)
      return (this.totalStatsIntern - referenceTotal) / referenceTotal * 100
    },
    totalStatsReferenceExtern () {
      let referenceTotal = this.statsReferenceSales.filter(x => ['sold', 'reserved'].includes(x.status)).reduce((a, b) => {
        if (b.account.pk !== this.accountPk) {
          return a + b.sale_price_ttc
        } else return a + 0
      }, 0)
      return (this.totalStatsExtern - referenceTotal) / referenceTotal * 100
    },
    cancelRate () {
      let cancelCount = []
      let validSalesCount = []
      if (this.filters.status.includes('sold') && this.filters.status.includes('reserved')) {
        // sold and reserved
        cancelCount = this.statsSales.filter(x => x.status === 'canceled' && x.signature_date).length
        validSalesCount = this.statsSales.filter(x => ['sold', 'reserved', 'canceled'].includes(x.status) && x.signature_date).length
      } else if (this.filters.status.includes('sold') && !this.filters.status.includes('reserved')) {
        // only sold
        cancelCount = this.statsSales.filter(x => x.status === 'canceled' && x.sale_date).length
        validSalesCount = this.statsSales.filter(x => ['sold', 'canceled'].includes(x.status) && x.sale_date).length
      } else if (!this.filters.status.includes('sold') && this.filters.status.includes('reserved')) {
        // only reserved
        cancelCount = this.statsSales.filter(x => x.status === 'canceled' && x.signature_date && !x.sale_date).length
        validSalesCount = this.statsSales.filter(x => ['reserved', 'canceled'].includes(x.status) && x.signature_date && !x.sale_date).length
      }
      return !validSalesCount && cancelCount ? 100 : validSalesCount ? cancelCount * 100 / validSalesCount : 0
    }
  },
  watch: {
    referenceSelected (v) {
      this.reference = v
    }
  },
  created () {
    this.reference = this.referenceDatas[0]
    this.updateReference()
  },
  methods: {
    updateFilters () {
      this.$emit('updateFilters', this.filters)
    },
    updateReference () {
      this.$emit('updateReference', this.reference)
    }
  }
}
</script>
